import type { TrackingLabels } from '@shared/tracking/TrackingLabels';

export function getSelectionRulesTracking(
    rule: string,
): Pick<TrackingLabels, 'wk.san_EntrySelectionRule' | 'wk.san_SelectionRule'> {
    const entryRule = window.history.state?.entryRule ?? rule;

    return {
        'wk.san_EntrySelectionRule': entryRule,
        'wk.san_SelectionRule': rule,
    };
}
